import type { ReactNode } from 'react';

export const symbol_language_us: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-280q-24.75 0-42.37-17.63Q160-315.25 160-340v-310q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v310h160v-310q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v310q0 24.75-17.62 42.37Q404.75-280 380-280H220Zm360 0q-24.75 0-42.37-17.63Q520-315.25 520-340v-10q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v10h160v-110H580q-24.75 0-42.37-17.63Q520-485.25 520-510v-110q0-24.75 17.63-42.38Q555.25-680 580-680h160q24.75 0 42.38 17.62Q800-644.75 800-620v10q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-10H580v110h160q24.75 0 42.38 17.62Q800-474.75 800-450v110q0 24.75-17.62 42.37Q764.75-280 740-280H580Z"
		/>
	</svg>
);
